import api from '@/api/api.js'

export default {
    getContextePaiementPrestataire(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/paiement-contexte', { dette_id: data.dette_id },
            { headers: { 'X-Tresorerie-Paiement': access_token }, med_access_scoped: true }).then(response => response.data)
    },

    payerDettePrestataire(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/payer', {
            dette_id: data.dette_id, montant: data.montant, requete_id: data.requete_id, commentaire: data.commentaire
        }, { headers: { 'X-Tresorerie-Paiement': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    getListeFournisseur() {
        const promise = api.comptabilite().get('/fournisseurs')
        return promise.then((response) => response.data)
    },

    getListeDette(data) {
        const promise = api.comptabilite().post('/dettes', data)
        return promise.then((response) => response.data)
    },

    importerDettesPrestataires(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/importer', { transfert: data.transfert },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },

    importerDettesPrestatairesV2(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/importer-v2', { transfert: data.transfert },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },

    getDetailDettePrestataire(data) {
        return api.comptabilite().post('/dettes/prestataires/detail', { dette_id: data.dette_id })
            .then(response => response.data)
    },

    appliquerCloturesPrestataires(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/clotures', { transfert: data.transfert },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },

    // Base unitaire redéfinie par la Trésorerie (refusée après un règlement).
    modifierBaseRemuneration(data, access_token) {
        return api.comptabilite().post('/dettes/prestataires/base', { ligne_id: data.ligne_id, base: data.base, user_nom: data.user_nom },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },

    saveDette(data) {
        const promise = api.comptabilite().post('/dettes/store', data)
        return promise.then((response) => response.data)
    },

    removeDette(data) {
        const promise = api.comptabilite().post('/dettes/delete', data)
        return promise.then((response) => response.data)
    },

    saveReglementDette(data) {
        const promise = api.comptabilite().post('/dettes/store/reglement', data)
        return promise.then((response) => response.data)
    },

    getListeHistoriqueDette(data) {
        const promise = api.comptabilite().post('/dettes/historique-paiement', data)
        return promise.then((response) => response.data)
    },

    checkIfDetteIsPaid(dette_id) {
        const promise = api.comptabilite().get('/dettes/'+dette_id+'/check-if-paid')
        return promise.then((response) => response.data)
    },

    getDetteMontantRestant(dette_id) {
        const promise = api.comptabilite().get('/dettes/'+dette_id+'/montant-restant')
        return promise.then((response) => response.data)
    },

    getListeRecapDepenseBudgetaire(data) {
        const promise = api.comptabilite().post('/ligne-budgetaire/recap', data)
        return promise.then((response) => response.data)
    },

    getListeRecapDepenseBudgetaireDetail(data) {
        const promise = api.comptabilite().post('/caisse-operations/depense-budgetaire', data)
        return promise.then((response) => response.data)
    },

    getListeApportSocial(data) {
        const promise = api.comptabilite().post('/ligne-budgetaire/apport-social', data)
        return promise.then((response) => response.data)
    },
}
